<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <app-list-header [title]="'Role'" [$parent]="getSelf()">
      </app-list-header>
    </div>
    <div class="col-md-12 mt-3">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <form class="applistform2">
                <!-- <div class="d-flex align-items-center">
                  <label for="appId" class="ml-sm-2 ml-2">App </label>
                  <select
                    [disabled]="form.searchParams['appId>=0']"
                    id="appId"
                    name="appId"
                    [(ngModel)]="form.searchParams['appId']"
                    class="form-control form-control-sm ms-2"
                  >
                    <option value="">--All--</option>
                    <option value="0">Global Roles</option>
                    <option
                      *ngFor="let e of form.preload.applist"
                      [value]="e.key"
                    >
                      {{ e.value }}
                    </option>
                  </select>
                </div> -->

                <!-- <div class="d-flex align-items-center">
                  <label for="sname" class="ms-sm-2">Name </label>
                  <input
                    type="text"
                    name="sname"
                    id="sname"
                    class="form-control form-control-sm ms-sm-2"
                    placeholder="Name"
                    [(ngModel)]="form.searchParams['name']"
                  />
                </div> -->

                <!-- <div class="d-flex align-items-center">
                    <label for="desc" class="ms-sm-2">Description</label>
                    <input
                      [(ngModel)]="form.searchParams['discription']"
                      type="text"
                      name="desc"
                      class="form-control form-control-sm ms-sm-2"
                      id="desc"
                      placeholder="Description"
                    />
                  </div> -->

                <!-- <button
                  title="Search"
                  (click)="search()"
                  class="btn btn-outline-primary btn-sm ms-sm-2 radius-30"
                >
                  <i class="fa fa-search-plus"></i> Search
                </button>
                <button
                  title="Reset"
                  (click)="resetSearchForm()"
                  class="btn btn-outline-primary btn-sm ms-sm-2 radius-30"
                >
                  <i class="fadeIn animated bx bx-reset"></i> Reset
                </button>
                <button
                  title="Add"
                  data-bs-toggle="modal"
                  data-bs-target="#editModal"
                  (click)="addRole()"
                  class="btn btn-outline-primary btn-sm ms-sm-2 radius-30"
                >
                  <i class="fa fa-plus"></i>Add
                </button> -->
                <a title="Application" class="btn btn-outline-primary btn-sm ms-sm-2 radius-30"
                  routerLink="../../applicationlist">
                  Application</a>
                <a title="Assign Menu" class="btn btn-outline-primary btn-sm ms-sm-2 radius-30" routerLink="../../menuassignment/{{
                    form.searchParams['appId']
                  }}">
                  Assign Menu
                </a>
                <a title="Assign Usecase" class="btn btn-outline-primary btn-sm ms-sm-2 radius-30" routerLink="../../approleusecase/{{
                    form.searchParams['appId']
                  }}">
                  Assign Usecase</a>
              </form>
              <div class="col-md-12 mt-3">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="table-responsive mb-3">
                          <table id="dataTableId" class="table">
                            <thead class="table-light">
                              <tr>
                                <th>
                                  S.No. {{ "AppId" }} ||
                                  {{ form.searchParams["appId"] }}
                                </th>
                                <th>Name</th>
                                <th>Description</th>
                                <th>Application</th>
                                <th>Access<br />Read/Write/Update/Delete</th>
                                <th>Status</th>
                                <th>Info</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let e of form.list; let i = index">
                                <td>{{ pageIndex(i) }}</td>
                                <td>
                                  <i *ngIf="e.status == 'Active'" class="fas fa-user-alt primary"
                                    style="font-size: 12px; color: green">
                                  </i>

                                  <i *ngIf="e.status != 'Active'" class="fas fa-user-alt primary"
                                    style="font-size: 12px; color: grey">
                                  </i>
                                  {{ e.name }}
                                </td>
                                <td>{{ e.discription }}</td>
                                <td>{{ e.applicationName }}</td>
                                <td>
                                  {{ e.canRead }}/{{ e.canWrite }}/{{
                                  e.canUpdate
                                  }}/{{ e.canDelete }}
                                </td>
                                <td>{{ e.status }}</td>
                                <td>
                                  <app-info-button [ele]="e"></app-info-button>
                                </td>
                                <td>
                                  <div class="d-flex order-actions">
                                    <a title="Edit" data-bs-toggle="modal" data-bs-target="#editModal"
                                      (click)="get(e.id)"><i class="fa fa-edit"></i></a>
                                    <a title="Delete" class="ms-1" (click)="delete(e.id)"><i
                                        class="fa fa-trash"></i></a>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <app-list-header [$parent]="getSelf()"></app-list-header>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- data entry form -->
<div class="modal fade" id="editModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Role</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" title="Close"></button>
      </div>
      <div class="modal-body">
        <div class="card">
          <div class="card-body p-4">
            <form #uiForm="ngForm">
              <p>
                <form-error [form]="form"></form-error>
              </p>
              <div class="row mb-3">
                <label for="fappId" class="col-sm-3 col-form-label">App </label>
                <div class="col-sm-9">
                  <select [disabled]="form.data['appId>=0']" id="fappId" name="fappId" [(ngModel)]="form.data['appId']"
                    class="form-select form-select-sm" required>
                    <option value="0">Global Role</option>
                    <option *ngFor="let e of form.preload.applist" [value]="e.key">
                      {{ e.value }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row mb-3">
                <label for="name" class="col-sm-3 col-form-label">Name </label>
                <div class="col-sm-9">
                  <input id="name" name="name" placeholder="Name" type="text" pattern="[a-zA-Z][a-zA-Z ]+"
                    class="form-control form-control-sm" required [(ngModel)]="form.data['name']" />
                </div>
              </div>
              <div class="row mb-3">
                <label for="status" class="col-sm-3 col-form-label">Status</label>
                <div class="col-sm-9">
                  <select id="status" name="status" required [(ngModel)]="form.data['status']"
                    class="form-select form-select-sm">
                    <option *ngFor="let e of statusList" [value]="e">
                      {{ e }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="row mb-3">
                <label for="canRead" class="col-sm-3 col-form-label">Read
                </label>
                <div class="col-sm-9">
                  <select id="canRead" name="canRead" [(ngModel)]="form.data['canRead']"
                    class="form-select form-select-sm" required>
                    <option *ngFor="let e of yesNo" [value]="e">
                      {{ e }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row mb-3">
                <label for="canWrite" class="col-sm-3 col-form-label">Write
                </label>
                <div class="col-sm-9">
                  <select id="canWrite" name="canWrite" [(ngModel)]="form.data['canWrite']"
                    class="form-select form-select-sm" required>
                    <option *ngFor="let e of yesNo" [value]="e">
                      {{ e }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row mb-3">
                <label for="canUpdate" class="col-sm-3 col-form-label">Update</label>
                <div class="col-sm-9">
                  <select id="canUpdate" name="canUpdate" [(ngModel)]="form.data['canUpdate']"
                    class="form-select form-select-sm" required>
                    <option *ngFor="let e of yesNo" [value]="e">
                      {{ e }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row mb-3">
                <label for="canDelete" class="col-sm-3 col-form-label">Delete
                </label>
                <div class="col-sm-9">
                  <select id="canDelete" name="canDelete" [(ngModel)]="form.data['canDelete']"
                    class="form-select form-select-sm" required>
                    <option *ngFor="let e of yesNo" [value]="e">
                      {{ e }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row mb-3">
                <label for="address" class="col-sm-3 col-form-label">Description</label>
                <div class="col-sm-9">
                  <textarea id="discription" name="discription" required placeholder="Description" type="text"
                    class="form-control form-control-sm" rows="2" [(ngModel)]="form.data['discription']">
                  </textarea>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button title="Save" class="btn btn-outline-primary btn-sm ml-2" [disabled]="!uiForm.valid"
              (click)="save()">
              <i class="fa fa-save"></i> Save
            </button>
            <button type="button" class="btn btn-outline-secondary btn-sm ml-2" data-bs-dismiss="modal" title="Close">
              <i class="fa fa-window-close"></i> Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Filter Modal -->
<div class="modal fade" id="scrollableModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Search</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" title="Close"></button>
      </div>

      <div class="modal-body">
        <div class="row mb-3">
          <label for="name" class="col-sm-3 col-form-label">Name:</label>
          <div class="col-sm-9">
            <div class="position-relative">
              <input type="text" class="form-control form-control-sm" id="name" placeholder="Enter name"
                [(ngModel)]="form.searchParams['name']" />
            </div>
          </div>
        </div>
        <!-- <div class="row mb-3">
            <label for="applicationCode" class="col-sm-3 col-form-label"
              >Skey:</label
            >
            <div class="col-sm-9">
              <div class="position-relative">
                <input
                  type="text"
                  class="form-control"
                  id="applicationCode"
                  name="applicationCode"
                  placeholder="Enter key"
                  [(ngModel)]="form.searchParams['applicationCode']"
                />
              </div>
            </div>
          </div> -->

        <div class="row mb-3">
          <label for="appId" class="col-sm-3 col-form-label">App</label>
          <div class="col-sm-9">
            <select [disabled]="form.searchParams['appId>=0']" class="form-select form-select-sm" id="appId"
              name="appId" [(ngModel)]="form.searchParams['appId']">
              <option value="">--All--</option>
              <option value="0">Global Roles</option>
              <option *ngFor="let e of form.preload.applist" [value]="e.key">
                {{ e.value }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary btn-sm radius-30 mt-2 mt-lg-0 ms-2" title="Search"
          (click)="search()">
          Apply Filter
        </button>
        <button (click)="resetSearchForm()" class="btn btn-outline-primary btn-sm radius-30 mt-2 mt-lg-0 ms-2"
          title="Reset">
          <i class="fa fa-eraser" aria-hidden="true"></i>
        </button>
        <button type="button" title="Close" class="btn btn-outline-secondary btn-sm radius-30 mt-2 mt-lg-0 ms-2"
          data-bs-dismiss="modal">
          <i class="fa fa-window-close"></i> Close
        </button>
      </div>
    </div>
  </div>
</div>